import OrganizationAiAssignmentsContent from '@UI/Pages/AiAssignments/OrganizationAiAssignments/OrganizationAiAssignmentsContent';
import AiAssignmentsNotifications from '@UI/Pages/AiAssignments/Shared/AiAssignmentsNotifications';
import LevelSwitch from '@Guidelines/Component/LevelSwitch';
import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';
import useAccessibleNavigationLevels from '@UI/Hooks/useAccessibleNavigationLevels';
import type * as React from 'react';

/**
 * Assembles the screen: header, the data-owning `OrganizationAiAssignmentsContent`, and the
 * notifications shared by the three affectation screens. The eyebrow is the
 * section label followed by the current organization's name once resolved.
 */
const OrganizationAiAssignmentsPage: React.FC = () => {
	const { currentOrganization } = useCurrentOrganization();
	const levels = useAccessibleNavigationLevels('ai-models');

	const eyebrow =
		currentOrganization !== null ? `CONFIGURATION · ${currentOrganization.name}` : 'CONFIGURATION';

	return (
		<PageContainer>
			<PageHeader
				eyebrow={eyebrow}
				title="Modèles de la structure"
				description="Affectez un modèle à chaque usage pour la structure courante : hérité du compte tant qu’aucun n’est défini ici, surchargeable par agence."
				actions={<LevelSwitch ariaLabel="Niveau des modèles d'IA" levels={levels} />}
			/>
			<OrganizationAiAssignmentsContent />
			<AiAssignmentsNotifications />
		</PageContainer>
	);
};

export default OrganizationAiAssignmentsPage;
